/* eslint-disable react/require-default-props */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import { AuthContext } from '../../shared/app/AuthProvider';
import { ReactComponent as IllustrationHorizontalSVG } from './assets/illustration-horizontal.svg';
import Card from '../../shared/card';

export const LotteryCard = ({ onClick }: { onClick: () => void }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Card
      id="cta_lottery_card"
      onClick={onClick}
      type="mentor"
      height="100%"
      header={
        <div className={classes.wrapper}>
          <IllustrationHorizontalSVG className={classes.illustration} />
        </div>
      }
      content={
        <div className={classes.content}>
          <h3 className={classes.title}>
            {t('v2.mentorOverview.mentorList_card_lotteryBooking_label_title')}
          </h3>
          <p className={classes.description}>
            {t('v2.mentorOverview.mentorList_card_lotteryBooking_label_body')}
          </p>
        </div>
      }
      ctaLabel={t('v2.mentorOverview.mentorList_card_lotteryBooking_cta_label')}
    />
  );
};

const BookMentorCallCard = ({ loading }: { loading?: boolean }) => {
  const { authUser } = React.useContext(AuthContext);

  const getCalendlyURL = () =>
    `${process.env.REACT_APP_CALL_CALENDLY_URL}?name=${
      authUser.attributes.given_name
    }&email=${encodeURIComponent(authUser.attributes.email)}`;

  const onOpen = () => {
    window.open(getCalendlyURL(), '_blank', 'noopener,noreferrer');
  };

  return <LotteryCard onClick={onOpen} />;
};

export default BookMentorCallCard;
